import Store from './store'
import Dispatcher from './dispatcher'
import {ActionCreator} from './actioncreator'
import {CreateStore} from './createstore'

const miniflux = {
    Store,
    Dispatcher,
    ActionCreator,
    CreateStore,
}

export default miniflux
